import React from "react";

// Card "Préstamos clientes" del dashboard de cobranza.
// Muestra el cruce entre préstamos a clientes de la facturación y las solicitudes de préstamo.
// TODO: conectar al endpoint real cuando exista. Mientras `data` no llegue se usan valores
// de ejemplo (PRESTAMOS_CLIENTES_EJEMPLO) para visualizar el diseño.
const PRESTAMOS_CLIENTES_EJEMPLO = {
    total_prestamos: 128,
    facturacion_con_solicitud: 97,
    facturacion_sin_solicitud: 31,
    solicitudes_sin_factura: 12,
};

const formatNumero = (valor) => Number(valor || 0).toLocaleString("es-MX");

export const ChartPrestamosClientes = ({ data }) => {
    const info = data ?? PRESTAMOS_CLIENTES_EJEMPLO;

    const metricas = [
        { key: "total", label: "Total préstamos", valor: info.total_prestamos, tipo: "neutral" },
        { key: "con-sol", label: "Facturados con solicitud", valor: info.facturados_con_solicitud, tipo: "ok" },
        { key: "sin-sol", label: "Facturados sin solicitud", valor: info.facturados_sin_solicitud, tipo: "alerta" },
        { key: "sin-fac", label: "Solicitudes sin factura", valor: info.solicitudes_sin_factura, tipo: "alerta" },
    ];

    return (
        <div className="prestamos-clientes-content">
            {metricas.map(({ key, label, valor, tipo }) => {
                const esCero = Number(valor || 0) === 0;
                const clase = tipo === "alerta" && esCero ? "ok" : tipo;
                return (
                    <div key={key} className={`prestamos-metric prestamos-metric--${clase}`}>
                        <span className="prestamos-metric-value">{formatNumero(valor)}</span>
                        <span className="prestamos-metric-label">{label}</span>
                    </div>
                );
            })}
        </div>
    );
};
